<template>
    <div class="step">
        <div class="step--heading active">
            <div class="inner">
                <span>1</span>
                <p>{{ solutionCategories.type_text }}</p>
            </div>
        </div>
        <div class="step--body">
            <p>{{ solutionCategories.desc }}</p>

            <div class="row">
                <div
                    class="col-lg-4"
                    v-for="(category, index) in solutionCategories.categories"
                    :key="index"
                >
                    <div
                        class="category"
                        :class="{ active: category.categoryId == categoryId, disabled: category.min == 0 && category.max == 0 }"
                        @click="setCategory(category)"
                    >
                        <div class="card-image">
                            <img :src="category.imageUrl" alt />
                        </div>
                        <div class="card-content">
                            <h2 :dusk="'cat_title_' + category.title">{{ category.title }}</h2>
                            <p class="desc">{{ category.shortDescription }}</p>
                        </div>

                        <div class="disabled-overlay" v-if="category.min == 0 && category.max == 0">
                            <p>{{ label_na_for_your_vehicle }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import minMaxPricing from "../../mixins/min-max-pricing.js";

export default {
    name: "platform-type",
    props: {
        solutionCategories: Object,
        label_na_for_your_vehicle: {
            type: String,
            required: true,
            default: "Not available for your vehicle"
        },
        categoryId: String
    },
    mixins: [minMaxPricing],
    methods: {
        setCategory(category) {
            this.$emit("categorySelected", category.categoryId);
            ga("send","event", "Fit My Vehicle", "Product Category", category.title);
            gtag('event', 'fit_my_vehicle_category', {'category':'Fit My Vehicle', 'action':"Product Category", value: category.title});
        }
    }
};
</script>
